import { useNavigate } from "react-router-dom";

import { RoutePath } from "../routerPaths";
import { CreateBatchWizard } from "./createWizard/CreateBatchWizard";

/**
 * Route wrapper for the customer-matching wizard. Keeps routing/navigation
 * concerns out of the wizard component itself — the wizard only knows how
 * to ask its host to exit.
 */
export default function PaymentRemittancePdfsNewPage() {
  const navigate = useNavigate();

  return (
    <CreateBatchWizard
      onExit={() => navigate(RoutePath.PaymentRemittancePdfs)}
    />
  );
}
